export const servicePages = [
    { label: 'Composable Architectures', link: '/expertise/composable-architectures', icon: 'dashboard' },
    { label: 'Headless Commerce', link: '/expertise/headless-commerce', icon: 'sell-cloud' },
    { label: 'Content Platforms & DXP', link: '/expertise/content-platforms-dxp', icon: 'graph5' },
    { label: 'Search & Discovery', link: '/expertise/search-and-discovery', icon: 'mystery' },
    { label: 'Digital Asset Management', link: '/expertise/digital-asset-management', icon: 'photoLibrary' },
    { label: 'Authentication & Identity', link: '/expertise/auth-and-identity', icon: 'familiarFace' },
    { label: 'Platform Migration & Modernization', link: '/expertise/platform-modernization', icon: 'route' },
    { label: 'UX & UI Design', link: '/expertise/ux-ui-design', icon: 'tactic' },
    { label: 'Research & Discovery', link: '/expertise/research-discovery', icon: 'labProfile' },
];

export const industryPages = [
    {
        label: 'B2B Technology',
        link: '/industries/technology',
        description: 'SaaS platforms & tech companies',
        icon: 'deployedCode',
    },
    {
        label: 'Associations & Member Organizations',
        link: '/industries/associations',
        description: 'Member organizations & trade groups',
        icon: 'group3',
    },
    { label: 'Commerce', link: '/industries/commerce', description: 'B2B & B2C e-commerce', icon: 'accountBalance' },
];

export const partnersPlatformsPages = [
    { label: 'Algolia', link: '/partners-and-platforms/algolia' },
    { label: 'AWS', link: '/partners-and-platforms/aws' },
    // { label: 'Bloomreach', link: '/partners-and-platforms/bloomreach' },
    // { label: 'Builder', link: '/partners-and-platforms/builder' },
    // { label: 'Bynder', link: '/partners-and-platforms/bynder' },
    { label: 'Cloudinary', link: '/partners-and-platforms/cloudinary' },
    { label: 'Contentful', link: '/partners-and-platforms/contentful' },
    // { label: 'Coveo', link: '/partners-and-platforms/coveo' },
    // { label: 'Craft CMS', link: '/partners-and-platforms/craft' },
    { label: 'Netlify', link: '/partners-and-platforms/netlify' },
    { label: 'Shopify', link: '/partners-and-platforms/shopify-plus' },
    { label: 'Stytch', link: '/partners-and-platforms/stytch' },
    // { label: 'Uniform', link: '/partners-and-platforms/uniform' },
];

export const aboutPages = [
    { label: 'Our Team', link: '/about/team' },
    { label: 'Our Values', link: '/about/values' },
    { label: 'The Journal', link: '/about/journal' },
    { label: 'Work at Foster Made', link: '/about/careers' },
];
